import axios from "axios";

const uninterceptedAxiosInstance = axios.create();
export { uninterceptedAxiosInstance };
